enum MoveType {
  DealDevelopmentCards = 'DEAL_DEVELOPMENT_CARDS',
  ChooseDevelopmentCard = 'CHOOSE_DEVELOPMENT_CARD',
  RevealChosenCards = 'REVEAL_CHOSEN_CARDS',
  PassCards = 'PASS_CARDS',
  DiscardLeftoverCards = 'DISCARD_LEFTOVER_CARDS',
  StartPhase = 'START_PHASE',
  Recycle = 'RECYCLE',
  SlateForConstruction = 'SLATE_FOR_CONSTRUCTION',
  PlaceResource = 'PLACE_RESOURCE',
  CompleteConstruction = 'COMPLETE_CONSTRUCTION',
  TransformIntoKrystallium = 'TRANSFORM_INTO_KRYSTALLIUM',
  TellYouAreReady = 'TELL_YOU_ARE_READY',
  Produce = 'PRODUCE',
  ReceiveCharacter = 'RECEIVE_CHARACTER',
  PlaceCharacter = 'PLACE_CHARACTER',
  Concede = 'CONCEDE'
}

export default MoveType